export const COUNTRIES: {
  [propName: string]: { [cityName: string]: string[] };
} = {
  Netherlands: {
    Drenthe: ["Assen", "Coevorden", "Emmen", "Hoogeveen", "Meppel"],
    Flevoland: ["Almere", "Biddinghuizen", "Emmeloord", "Lelystad"],
    Friesland: [
      "Bolsward",
      "Dokkum",
      "Franeker",
      "Harlingen",
      "Hindeloopen",
      "IJlst",
      "Leeuwarden",
      "Sloten",
      "Sneek",
      "Stavoren",
      "Workum"
    ],
    Gelderland: [
      "Apeldoorn",
      "Arnhem",
      "Bredevoort",
      "Buren",
      "Borculo",
      "Culemborg",
      "Dieren",
      "Doetinchem",
      "Ede",
      "Enspijk",
      "Gendt",
      "Groenlo",
      "Harderwijk",
      "Hattem",
      "Heukelum",
      "Huissen",
      "Nijkerk",
      "Nijmegen",
      "Staverden",
      "Tiel",
      "Ulft",
      "Voorst",
      "Wageningen",
      "Wijchen",
      "Winterswijk",
      "Zaltbommel",
      "Zevenaar",
      "Zutphen"
    ],
    Groningen: [
      "Appingedam",
      "Delfzijl",
      "Groningen",
      "Hoogezand-Sappemeer",
      "Stadskanaal",
      "Veendam",
      "Winschoten"
    ],
    Limburg: [
      "Echt",
      "Geleen",
      "Gennep",
      "Heerlen",
      "Kerkrade",
      "Tegelen",
      "Kessel",
      "Landgraaf",
      "Maastricht",
      "Montfort",
      "Nieuwstadt",
      "Roermond",
      "Schin op Geul",
      "Sittard",
      "Stein",
      "Susteren",
      "Thorn",
      "Vaals",
      "Valkenburg",
      "Venlo",
      "Weert"
    ],
    "North Brabant": [
      "Den Bosch",
      "Bergen op Zoom",
      "Boxtel",
      "Breda",
      "Eindhoven",
      "Geertruidenberg",
      "Geldrop",
      "Grave",
      "Helmond",
      "Heusden",
      "Klundert",
      "Oosterhout",
      "Oss",
      "Ravenstein",
      "Roosendaal",
      "Sint-Oedenrode",
      "Tilburg",
      "Valkenswaard",
      "Veldhoven",
      "Waalwijk",
      "Willemstad",
      "Woudrichem"
    ],
    "North Holland": [
      "Alkmaar",
      "Amstelveen",
      "Amsterdam",
      "Bussum",
      "Den Helder",
      "Diemen",
      "Edam",
      "Enkhuizen",
      "Haarlem",
      "Heerhugowaard",
      "Hilversum",
      "Hoofddorp",
      "Hoorn",
      "Laren",
      "Medemblik",
      "Monnickendam",
      "Muiden",
      "Naarden",
      "Purmerend",
      "Schagen",
      "Velsen",
      "Volendam",
      "Weesp",
      "Zaanstad"
    ],
    Overijssel: [
      "Almelo",
      "Blokzijl",
      "Deventer",
      "Enschede",
      "Genemuiden",
      "Hasselt",
      "Hengelo",
      "Kampen",
      "Oldenzaal",
      "Rijssen",
      "Steenwijk",
      "Vollenhove",
      "Zwolle"
    ],
    "South Holland": [
      "Alphen aan den Rijn",
      "Capelle aan den IJssel",
      "Delft",
      "Dordrecht",
      "Gorinchem",
      "Gouda",
      "Den Haag",
      "Leiden",
      "Maassluis",
      "Rotterdam",
      "Schiedam",
      "Spijkenisse",
      "Vlaardingen",
      "Voorburg",
      "Voorschoten"
    ],
    Utrecht: [
      "Amersfoort",
      "Baarn",
      "Bilthoven",
      "Bunschoten",
      "Eemnes",
      "Hagestein",
      "Houten",
      "Leerdam",
      "Montfoort",
      "Nieuwegein",
      "Oudewater",
      "Rhenen",
      "Utrecht",
      "Veenendaal",
      "Vianen",
      "Wijk bij Duurstede",
      "Woerden",
      "IJsselstein",
      "Zeist"
    ],
    Zeeland: [
      "Arnemuiden",
      "Goes",
      "Hulst",
      "Middelburg",
      "Sluis",
      "Terneuzen",
      "Veere",
      "Vlissingen",
      "Zierikzee"
    ]
  }
};
